import * as axios from "axios";
import { getAuthHeader } from "./../utils";

export const getUnitLeaveReport = () => {
  const url = `${process.env.REACT_APP_BASE_URL}unit-leaves-management/leave-report`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getPrintLog = (page:any) => {
  const url = `${process.env.REACT_APP_BASE_URL}print-log/${page}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const serachPrintLog = (model:any) => {
  const url = `${process.env.REACT_APP_BASE_URL}serach/print-log`;
  return axios.post(url, model ,getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const bulkUpdateBalance = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}unit-leaves-management/bulk-update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getUnitLeaveRequest = (date: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}unit-leaves-management/leave-request?dt=${date}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getUserProxyLeaveDetail = (userCode: string, year: number) => {
  const url = `${process.env.REACT_APP_BASE_URL}unit-leaves-management/user-detail?uc=${userCode}&yr=${year}`;
  return axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const addLeaveDetail = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}unit-leaves-management/request-leave`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};
